import { supabase } from "@/lib/supabase";
import type { TranscribeRequest, SummarizeRequest, Transcript, Summary } from "@/types";

const MIME_TO_EXT: Record<string, string> = {
  "audio/webm": "webm",
  "audio/mp4": "m4a",
  "audio/mpeg": "mp3",
  "audio/wav": "wav",
  "audio/ogg": "ogg",
  "audio/flac": "flac",
  "audio/x-m4a": "m4a",
  "audio/aac": "m4a",
  "video/mp4": "mp4",
  "video/webm": "webm",
};

export async function uploadAudioBlob(
  meetingId: string,
  blob: Blob,
  mimeType: string
): Promise<string> {
  const {
    data: { user },
  } = await supabase.auth.getUser();
  if (!user) throw new Error("Not authenticated");

  const ext = MIME_TO_EXT[mimeType] ?? "webm";
  const path = `${user.id}/${meetingId}.${ext}`;

  const { error } = await supabase.storage
    .from("meetings")
    .upload(path, blob, { contentType: mimeType, upsert: true });

  if (error) throw error;
  return path;
}

export async function transcribeMeeting(
  params: TranscribeRequest
): Promise<Transcript> {
  const { data, error } = await supabase.functions.invoke("transcribe", {
    body: params,
  });
  if (error) throw error;
  return data as Transcript;
}

export async function summarizeMeeting(
  params: SummarizeRequest
): Promise<Summary> {
  const { data, error } = await supabase.functions.invoke("summarize", {
    body: params,
  });
  if (error) throw error;
  return data as Summary;
}
